const  isLoggedIn = () => {
    const token = window.localStorage?.getItem("devToken");
    // console.log('token', token)
    return  token && token.length >0 ;
};
export default isLoggedIn;